<div class="flex flex-wrap gap-3" [ngClass]="{ 'flex-column': !!formField?.inline }">
  <div class="flex align-items-center" *ngFor="let option of formField.options">
    <p-radioButton
      styleClass="pm-form-field-radio-button"
      [name]="formField.value"
      [value]="option.value"
      [inputId]="option.value"
      [formControl]="ctrl"
    />
    <label [for]="option.value" class="pm-form-field-radio-label p5 ml-2">
      @if (option?.htmlLabel) {
        <span [innerHTML]="option.htmlLabel" class="w-full flex align-items-center"></span>
      } @else {
        {{ option.label }}
      }
    </label>
  </div>
</div>
